
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  statusLog: 'idle',
  exitDataL: 'idle',
};

export const exitSession = createAsyncThunk(
  'logout/exit',
  async (data) => {
    return data;
  }
)


export const logoutSlice = createSlice({
  name: 'logout',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(exitSession.pending, (state) => {
        state.statusLog = 'loading';
      })
      .addCase(exitSession.fulfilled, (state,action) => {
        state.statusLog = 'fullfilled';
        state.exitDataL = action.payload;
      })
      
  },
});

export const { reset } = logoutSlice.actions;

export const selectstatusLog = (state) => state.logout.statusLog;
export const selectExitLog = (state) => state.logout.exitDataL;
export default logoutSlice.reducer;
